import React from 'react';
import { useSelector } from 'react-redux';

import Security from './security';
import ContainerSectionMobile from '../../components/containerSectionMobile';
import ContainerSectionDesktop from '../../components/containerSectionDesktop';

import './securityProfile.scss';

const SecurityProfileScreen = () => {
  const isMobileDevice = useSelector((state) => state.mediaQuery.isMobileDevice);

  return (
    isMobileDevice ? (
      <ContainerSectionMobile className="profile-information">
        <Security isMobileDevice={isMobileDevice} />
      </ContainerSectionMobile>
    ) : (
      <ContainerSectionDesktop>
        <Security isMobileDevice={isMobileDevice} />
      </ContainerSectionDesktop>
    )
  );
};

export default SecurityProfileScreen;
